export const VERSION_CONTROL_GRID = 'VERSION_CONTROL_GRID';
export const VERSION_CONTROL_DATABASE = 'VERSION_CONTROL_DATABASE';
